import { base64toFile } from "../../utils/File/fileUtils";
import axios from "../http-client/axios";
import { SCORPIONS_URL } from "../urls/base-urls";

function mapperResponseFiles(response, participantsError) {
  response.participantsError = participantsError;
  return response;
}

export async function addAssembly(formData, formFile) {
  let formRequest = new FormData();
  let participantsError = [];

  const formDataBlob = new Blob([JSON.stringify(formData)], {
    type: "application/json",
  });

  formRequest.append("model", formDataBlob);

  if (formFile.length > 0) {
    formFile.forEach((file) => formRequest.append("file", file));

    const respFiles = await axios.post(`${SCORPIONS_URL}/admin/assembly/split-file`, formRequest);
    
    let resp;
    let idx = 0;
    let idAssembly = null;
    for (const fileResp of respFiles.data.files) {
      let formRequestData = new FormData();
      formRequestData.append("model", formDataBlob);

      let files = [];
      const fileResponse = base64toFile(fileResp.fileBase64, fileResp.name)
      files.push(fileResponse);
      formRequestData.append("file", fileResponse);

      if (idx == 0) {
        resp = await axios.post(`${SCORPIONS_URL}/admin/assembly/create`, formRequestData);
        idAssembly = resp.data.id;
        participantsError = [...participantsError, ...resp.data.participantError];
      } else {
        formData.id = idAssembly;
        resp = await updateAssembly(formData, files);
        participantsError = [...participantsError, ...resp.participantError];
      }      
      idx++;
    }
    return mapperResponseFiles( idx == 0 ? resp.data : resp, participantsError);
  } else {
    if (formFile.length > 0) {
      formFile.forEach((file) => formRequest.append("file", file));
    }

    const resp = await axios.post(`${SCORPIONS_URL}/admin/assembly/create`, formRequest);
    participantsError = [...participantsError, ...resp.data.participantError];
    return mapperResponseFiles(resp.data, participantsError);
  }
}

export async function getReport(data) {
 
 const resp = await axios({
   url: `${SCORPIONS_URL}/admin/assembly/report-participant-error`,
   method: "post",
   data: data,
   headers: { "content-type": "application/json" },
 });

 return resp.data;
}


export async function getAssemblies(filter, page, size) {
  let query = `?page=${page}&size=${size}`;

  if(filter)
    query += `&filter=${filter}`

  const resp = await axios.get(`${SCORPIONS_URL}/admin/assembly/list${query}`);

  return resp.data;
}


export async function deleteAssembly(id) {

  const resp = await axios.delete(`${SCORPIONS_URL}/admin/assembly?id=${id}`);
  return resp.data;
}

export async function deleteAssemblyParticipants(id) {
  const resp = await axios.delete(`${SCORPIONS_URL}/admin/assembly/participants?id=${id}`);
  return resp.data;
}

export async function getAssemblyReport(id) {
  const resp = await axios.get(`${SCORPIONS_URL}/admin/assembly/report-event?id=${id}`);
  return resp.data;
}



export async function getAssemblyParticipantsList(crms, page, size) {
  let query = `?crms=${crms}&page=${page}&size=${size}`
  const resp = await axios({
    url: `${SCORPIONS_URL}/admin/assembly/report-participant-list${query}`,
    method: "get",
    headers: {
      "content-type": "application/json",
    },
  });
  return resp.data;
}


export async function downloadAssemblyParticipants(crms) {
  let query = `?crms=${crms}`
  const resp = await axios({
    url: `${SCORPIONS_URL}/admin/assembly/report-participant${query}`,
    method: "get",
    headers: {
      "content-type": "application/json",
    },
  });
  return resp.data;
}

export async function updateAssembly(formData, formFile) {
  let formRequest = new FormData();
  const formDataBlob = new Blob([JSON.stringify(formData)], {
    type: "application/json",
  });

  formRequest.append("model", formDataBlob);

  if (formFile.length > 0) {
    formFile.forEach((file) => formRequest.append("file", file));
  }

  const resp = await axios.put(
    `${SCORPIONS_URL}/admin/assembly`
    , formRequest
  );

  return resp.data;
}

//  eslint-disable-next-line no-unused-vars
export async function getAssemblyById(id) {
  const resp = await axios({
    url: `${SCORPIONS_URL}/admin/assembly?id=${id}`,
    method: "get",
    data: {},
    headers: { "content-type": "application/json" },
  });

  if (resp.data) {
    return mapperResponse(resp.data);  
  }
}

function mapperResponse(response) {
  
  response.participantsDB = response.participants;
  response.participants = null;
  return response;
}

export async function getAssemblyParticipation(filter, page, size) {
  let query = `?page=${page}&size=${size}`;

  if(filter)
    query += `&filter=${filter}`

  const resp = await axios.get(
     `${SCORPIONS_URL}/assembly/list${query}`
  );
  return resp.data;
}